/* Atelier Bois theme runtime: smooth scroll, drawers, ambient media, and AJAX cart.
   Liquid-native replacement for the prototype's site.js. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Smooth scroll (Lenis) ---- */
  if (window.Lenis && !reduce && document.documentElement.dataset.smooth === 'true') {
    var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true });
    requestAnimationFrame(function raf(t) { lenis.raf(t); requestAnimationFrame(raf); });
  }

  /* ---- Drawers / overlays ---- */
  var panelTrigger = null;
  function scrim() { return document.getElementById('Scrim'); }
  function openPanel(id, trigger) {
    var p = document.getElementById(id); if (!p) return;
    panelTrigger = trigger || null;
    p.classList.add('open'); var s = scrim(); if (s) s.classList.add('open');
    p.setAttribute('aria-hidden', 'false');
    if (panelTrigger) panelTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var closeButton = p.querySelector('[data-close]'); if (closeButton) closeButton.focus();
  }
  function closePanels() {
    document.querySelectorAll('.panel.open').forEach(function (p) { p.classList.remove('open'); p.setAttribute('aria-hidden', 'true'); });
    var s = scrim(); if (s) s.classList.remove('open');
    document.body.style.overflow = '';
    if (panelTrigger) { panelTrigger.setAttribute('aria-expanded', 'false'); panelTrigger.focus(); }
    panelTrigger = null;
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openPanel(o.getAttribute('data-open'), o); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'Scrim') closePanels();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanels(); return; }
    if (e.key !== 'Tab') return;
    var panel = document.querySelector('.panel.open'); if (!panel) return;
    var focusable = [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first=focusable[0], last=focusable[focusable.length-1];
    if (e.shiftKey && document.activeElement===first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement===last) { e.preventDefault(); first.focus(); }
  });

  /* ---- ambient film cadence ---- */
  function initAmbientMedia(root) {
    (root || document).querySelectorAll('[data-ambient-media]:not([data-media-ready])').forEach(function (media) {
      media.setAttribute('data-media-ready', 'true');
      var video = media.querySelector('video');
      if (!video) return;
      var cadence = media.getAttribute('data-media-cadence');
      var replayTimer = null;
      function ready() {
        if (reduce) return;
        media.classList.add('is-playing');
        media.classList.remove('is-resetting', 'is-resting');
      }
      function failed() { media.classList.remove('is-playing'); media.classList.add('is-failed'); video.pause(); }
      video.addEventListener('playing', ready);
      video.addEventListener('loadeddata', ready);
      video.addEventListener('error', failed, true);
      Array.prototype.forEach.call(video.querySelectorAll('source'), function (source) { source.addEventListener('error', failed); });
      if (cadence === 'hero') {
        video.loop = false;
        video.addEventListener('ended', function () {
          if (reduce) return;
          media.classList.add('is-resting');
          window.clearTimeout(replayTimer);
          replayTimer = window.setTimeout(function () {
            media.classList.add('is-resetting');
            window.setTimeout(function () {
              try { video.currentTime = 0; } catch (e) {}
              var replay = video.play();
              if (replay && replay.catch) replay.catch(function () {});
            }, 1100);
          }, 12000);
        });
      }
      if (video.readyState >= 2) ready();
      if (reduce) { video.pause(); try { video.currentTime = 0; } catch (e) {} }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initAmbientMedia(); });
  document.addEventListener('shopify:section:load', function (e) { initAmbientMedia(e.target); });

  /* ---- restrained motion for video-led sections ---- */
  (function () {
    if (reduce) return;
    var targets = [];
    var ticking = false;
    function collect(root) {
      (root || document).querySelectorAll('[data-scroll-motion="cinematic"]').forEach(function (el) {
        if (targets.indexOf(el) === -1) targets.push(el);
      });
      requestTick();
    }
    function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
    function render() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var mobileFactor = window.innerWidth < 720 ? 0.62 : 1;
      targets = targets.filter(function (el) { return document.documentElement.contains(el); });
      targets.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > vh + 120) return;
        var position = (rect.top + rect.height * 0.5 - vh * 0.5) / (vh + rect.height);
        var speed = parseFloat(el.getAttribute('data-scroll-speed') || '14') * mobileFactor;
        var zoom = parseFloat(el.getAttribute('data-scroll-zoom') || '0.012') * mobileFactor;
        var focus = clamp(1 - Math.abs(position) * 2.35, 0, 1);
        el.style.setProperty('--ab-scroll-y', (-position * speed).toFixed(2) + 'px');
        el.style.setProperty('--ab-scroll-scale', (1 + focus * zoom).toFixed(4));
      });
    }
    function requestTick() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
    document.addEventListener('DOMContentLoaded', function () { collect(); });
    document.addEventListener('shopify:section:load', function (e) { collect(e.target); });
  })();

  /* ---- AJAX cart ---- */
  function money(c) {
    var dollars = c / 100;
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: (c % 100 ? 2 : 0), maximumFractionDigits: 2 });
  }
  function sized(url, px) { return url ? url.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_' + px + 'x$1$2') : ''; }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
    var wrap = document.getElementById('CartItems'); var foot = document.getElementById('CartFoot');
    if (!wrap) return;
    if (cart.item_count === 0) {
      wrap.innerHTML = '<div class="empty"><div class="serif">Your cart is empty</div><a class="btn" href="/collections/all">Explore the Collection</a></div>';
      if (foot) foot.style.display = 'none'; return;
    }
    if (foot) foot.style.display = '';
    wrap.innerHTML = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(' &middot; ');
      return '<div class="citem" data-key="' + it.key + '">' +
        '<img src="' + sized(it.image, 120) + '" alt="">' +
        '<div><div class="ci-n">' + it.product_title + '</div><div class="ci-m">' + opts + '</div>' +
        '<button class="ci-x" data-remove="' + it.key + '">Remove</button></div>' +
        '<div class="ci-p">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    var sub = document.getElementById('CartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
  }
  function refresh() { return getCart().then(renderCart); }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart' });
      return refresh();
    }).then(function () { openPanel('CartDrawer'); })
      .catch(function (err) { alert(err.message); });
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]'); if (rm) { e.preventDefault(); changeQty(rm.getAttribute('data-remove'), 0); return; }
    var qa = e.target.closest('[data-add-id]'); if (qa) { e.preventDefault(); addToCart(parseInt(qa.getAttribute('data-add-id'), 10), 1); return; }
    var co = e.target.closest('a[href*="/checkout"]'); if (co && window.dataLayer) window.dataLayer.push({ event: 'begin_checkout' });
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[name="id"]'); if (!idEl || !idEl.value) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    addToCart(parseInt(idEl.value, 10), qtyEl ? parseInt(qtyEl.value, 10) : 1);
  });

  document.addEventListener('DOMContentLoaded', refresh);

  /* ---- rotating announcement bar ---- */
  (function () {
    var items = document.querySelectorAll('#Announce .ann-item');
    if (items.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4800);
  })();

  /* ---- back-to-top ---- */
  (function () {
    var btn = document.getElementById('ToTop');
    if (!btn) return;
    function onScroll() { if (window.scrollY > 700) btn.classList.add('show'); else btn.classList.remove('show'); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      try { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    });
  })();

  /* ---- newsletter lead dialog ---- */
  (function () {
    var root = document.getElementById('NewsletterLead');
    var dialog = document.getElementById('NewsletterDialog');
    if (!root || !dialog || typeof dialog.showModal !== 'function') return;
    var widget = root.querySelector('.newsletter-lead__widget');
    var phone = root.querySelector('#NewsletterPhone');
    var phonePermission = root.querySelector('[data-newsletter-phone-permission]');
    var phonePermissionInput = phonePermission ? phonePermission.querySelector('input') : null;
    var dismissedKey = 'ab_newsletter_dismissed_at';
    var successKey = 'ab_newsletter_joined';
    var suppressFor = 30 * 24 * 60 * 60 * 1000;
    var remaining = 10000;
    var startedAt = 0;
    var timer = null;
    var opener = null;
    var success = root.querySelector('[data-newsletter-success]');
    var errors = root.querySelector('[data-newsletter-errors]');

    function pushEvent(name) {
      if (window.dataLayer) window.dataLayer.push({ event: name });
    }
    function showWidget() { if (widget) widget.classList.add('is-visible'); }
    function panelsOpen() { return !!document.querySelector('.panel.open'); }
    function open(trigger, source) {
      if (dialog.open || panelsOpen()) return false;
      opener = trigger || document.activeElement;
      dialog.showModal();
      document.body.classList.add('newsletter-open');
      var first = dialog.querySelector('[data-newsletter-success],[data-newsletter-errors],input:not([type="hidden"]),button');
      if (first) window.setTimeout(function () { first.focus(); }, 30);
      if (source === 'timer') pushEvent('newsletter_prompt_view');
      if (source === 'widget') pushEvent('newsletter_widget_open');
      return true;
    }
    function dismiss() {
      if (dialog.open) dialog.close();
      document.body.classList.remove('newsletter-open');
      try { localStorage.setItem(dismissedKey, String(Date.now())); } catch (e) {}
      showWidget();
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    }
    function eligible() {
      try {
        if (localStorage.getItem(successKey) === 'true') return false;
        var dismissedAt = parseInt(localStorage.getItem(dismissedKey) || '0', 10);
        return !dismissedAt || Date.now() - dismissedAt > suppressFor;
      } catch (e) { return true; }
    }
    function stopTimer() {
      if (!timer) return;
      window.clearTimeout(timer);
      timer = null;
      if (startedAt) remaining = Math.max(0, remaining - (Date.now() - startedAt));
      startedAt = 0;
    }
    function startTimer() {
      if (!eligible() || dialog.open || document.hidden || timer) return;
      startedAt = Date.now();
      timer = window.setTimeout(function attempt() {
        timer = null;
        remaining = 0;
        if (!open(null, 'timer')) {
          remaining = 1200;
          startTimer();
        }
      }, remaining);
    }
    root.querySelectorAll('[data-newsletter-close]').forEach(function (button) { button.addEventListener('click', dismiss); });
    document.querySelectorAll('[data-newsletter-open]').forEach(function (button) {
      button.addEventListener('click', function () { open(button, 'widget'); });
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(); });
    dialog.addEventListener('close', function () { document.body.classList.remove('newsletter-open'); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopTimer(); else startTimer(); });
    if (phone && phonePermission) phone.addEventListener('input', function () {
      var hasPhone = phone.value.trim().length > 0;
      phonePermission.hidden = !hasPhone;
      if (phonePermissionInput) { phonePermissionInput.required = hasPhone; if (!hasPhone) phonePermissionInput.checked = false; }
    });
    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', function () { pushEvent('newsletter_submit'); });
    if (success) {
      try { localStorage.setItem(successKey, 'true'); } catch (e) {}
      if (widget) { widget.classList.add('is-visible'); var label = widget.querySelector('[data-newsletter-widget-label]'); if (label) label.textContent = 'You are on the list'; }
      pushEvent('newsletter_success');
      open(null, 'success');
      success.focus();
      return;
    }
    if (errors) { showWidget(); open(null, 'error'); errors.focus(); return; }
    if (!eligible()) showWidget(); else startTimer();
  })();

  /* ---- sticky catalog offset ---- */
  (function () {
    var announcement = document.getElementById('shopify-section-announcement');
    var header = document.querySelector('header.site');
    if (!header) return;
    function measure() {
      var announcementHeight = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--ab-announcement-height', announcementHeight + 'px');
      document.documentElement.style.setProperty('--ab-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) {
      var stickyObserver = new ResizeObserver(measure);
      stickyObserver.observe(header);
      if (announcement) stickyObserver.observe(announcement);
    }
  })();

  window.AB = { add: addToCart, refresh: refresh, open: openPanel, close: closePanels };
})();
